var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9,11H2c-1.103,0-2,.897-2,2v6.5c0,2.481,2.019,4.5,4.5,4.5h4.5c1.103,0,2-.897,2-2v-9c0-1.103-.897-2-2-2Zm1,11c0,.552-.448,1-1,1h-4.5c-1.93,0-3.5-1.57-3.5-3.5v-6.5c0-.552.448-1,1-1h7c.552,0,1,.448,1,1v9ZM9,0h-4.5C2.019,0,0,2.019,0,4.5v2.5c0,1.103.897,2,2,2h7c1.103,0,2-.897,2-2V2c0-1.103-.897-2-2-2Zm1,7c0,.552-.448,1-1,1H2c-.552,0-1-.448-1-1v-2.5c0-1.93,1.57-3.5,3.5-3.5h4.5c.552,0,1,.448,1,1v5Zm12,8h-7c-1.103,0-2,.897-2,2v5c0,1.103.897,2,2,2h4.5c2.481,0,4.5-2.019,4.5-4.5v-2.5c0-1.103-.897-2-2-2Zm1,4.5c0,1.93-1.57,3.5-3.5,3.5h-4.5c-.552,0-1-.448-1-1v-5c0-.552.448-1,1-1h7c.552,0,1,.448,1,1v2.5ZM19.5,0h-4.5c-1.103,0-2,.897-2,2v9c0,1.103.897,2,2,2h7c1.103,0,2-.897,2-2v-6.5c0-2.481-2.019-4.5-4.5-4.5Zm3.5,11c0,.552-.448,1-1,1h-7c-.552,0-1-.448-1-1V2c0-.552.448-1,1-1h4.5c1.93,0,3.5,1.57,3.5,3.5v6.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.4320865e37c83bea75bc45f037005ac6.svg";
export { ForwardRef as ReactComponent };